export default __webpack_public_path__ + "static/media/more_time.d7843318.svg";